import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import * as typeformEmbed from '@typeform/embed';
import { sendDailyPoll as sendDailyPollAction } from 'actions/polls';
import styled from 'styled-components';

const WrapperTypeform = styled.div`
    position: relative;
    height: calc(100vh - 100px);
`;

const TypeformEmbed = ({ veificationKey, formId, sendDailyPoll }) => {
    const typeformRef = useRef(null);
    const typeformUrl = process.env.REACT_APP_TYPEFORM_URL;

    useEffect(() => {
        typeformEmbed.makeWidget(typeformRef.current, `${typeformUrl}/${formId}?typeform-welcome=0`, {
            hideFooter: true,
            hideHeaders: true,
            onSubmit: (e) => sendDailyPoll(veificationKey, e.response_id),
        });
    }, [typeformRef]);

    return <WrapperTypeform className="wrapper-typeform" ref={typeformRef} />;
};

const mapDispatchToProps = (dispatch) => ({
    sendDailyPoll: (key, responseId) => dispatch(sendDailyPollAction(key, responseId)),
});

export default connect(null, mapDispatchToProps)(TypeformEmbed);
